import { Checkbox, Option, Radio, RadioGroup, Select, Text, TextArea } from 'informed';
import * as React from 'react';

import formatDate from "../../../helpers/formatDate";
import GeneralConstants from '../../../constants/general.constants';
import CommentFormDisplay from '../../comments/comment-form-display.component';
import ProjectFormTextInput from '../../project-form-elements/project-form-text-input/project-form-text-input.component';
import DropTownHeaderCheckBox from '../../project-form-elements/dropdown-header-checkbox/dropdown-header-checkbox.component';
import ButtonAndInputContainer from '../../project-form-elements/button-and-input-container/button-and-input-container.component';
import ProjectAddCommentButton from '../../project-form-elements/project-add-comment-button/project-add-comment-button.component';
import ProjectRadioFreeContainer from '../../project-form-elements/project-radio-free-container/project-radio-free-container.component';
import ButtonAndOptionsContainer from '../../project-form-elements/button-and-options-container/button-and-options-container.component';

const ProjectFormBathroom = (props) => {
	const { is_workdrawing_sent, doorhandle, order_type, sink } = props.formData;

	const { handleShowComments, comments, activeFormData, formState } = props;

	const [hide_order_type, setOrderTypeMode] = React.useState('false');

	const [hide_sink, setSinkMode] = React.useState('false');

	const [hide_doorhandle, setDoorhandleMode] = React.useState('false');

	const [hide_is_workdrawing_sent, setIsWorkdrawingSentMode] = React.useState('false');

	const todayDate = new Date().toISOString().substring(0, 10);

	React.useEffect(() => {
		const isOrderType = localStorage.getItem('hide_order_type') === 'true';
		setOrderTypeMode(isOrderType);
		const isSink = localStorage.getItem('hide_sink') === 'true';
		setSinkMode(isSink);
		const isDoorhandle = localStorage.getItem('hide_doorhandle') === 'true';
		setDoorhandleMode(isDoorhandle);
		const isWorkdrawingSent = localStorage.getItem('hide_is_workdrawing_sent') === 'true';
		setIsWorkdrawingSentMode(isWorkdrawingSent);
	}, [hide_order_type, hide_doorhandle, hide_is_workdrawing_sent, hide_sink]);

	const toggle = (ev, section) => {
		ev.preventDefault();
		if (section == 'order_type') {
			const isOrderType = !hide_order_type;
			localStorage.setItem('hide_order_type', JSON.stringify(isOrderType));
			setOrderTypeMode(isOrderType);
		} else if (section == 'doorhandle') {
			const isDoorhandle = !hide_doorhandle;
			localStorage.setItem('hide_doorhandle', JSON.stringify(isDoorhandle));
			setDoorhandleMode(isDoorhandle);
		} else if (section == 'is_workdrawing_sent') {
			const isWorkdrawingSent = !hide_is_workdrawing_sent;
			localStorage.setItem('hide_is_workdrawing_sent', JSON.stringify(isWorkdrawingSent));
			setIsWorkdrawingSentMode(isWorkdrawingSent);
		} else if (section == 'sink') {
			const isSink = !hide_sink;
			localStorage.setItem('hide_sink', JSON.stringify(isSink));
			setSinkMode(isSink);
		}
	};

	const [order_type_val, setOrderType] = React.useState(order_type.brands.value);

	return (
		<>
			<div className='dropdown-container'>
				<div
					className={`dropdown-header-container dropdown-container__header ${
						hide_order_type ? 'dropdown-container__header--closed' : null
					} `}
				>
					<a href='' className='dropdown-container-trigger' onClick={(ev) => toggle(ev, 'order_type')}>
						{order_type.label}
					</a>
					<div className='dropdown-status-container'>
						<DropTownHeaderCheckBox
							name='order_type[dates][ordered][value]'
							label={order_type.dates.ordered.label}
							activeFormData={order_type.dates.ordered.value === true}
						/>
						<DropTownHeaderCheckBox
							name='order_type[dates][approved][value]'
							label={order_type.dates.approved.label}
							activeFormData={order_type.dates.approved.value === true}
						/>
						<DropTownHeaderCheckBox
							name='order_type[dates][delivered][value]'
							dateName='order_type[dates][delivered_date][value]'
							label={order_type.dates.delivered.label}
							activeFormDateData={order_type.dates.delivered_date.value ?? todayDate}
							activeFormData={order_type.dates.delivered.value === true}
							todayDate={todayDate}
						/>
						<ProjectAddCommentButton
							handleShowComments={handleShowComments}
							extraClass={false}
							targetId='order_type.header'
							group='order_type'
							comments={comments}
							label={order_type.label}
						/>
					</div>
				</div>
				<div
					className={`local-grid local-grid--col-4 dropdown-content-initial-options ${
						hide_order_type ? 'local-grid--hidden' : null
					}`}
				>
					<CommentFormDisplay targetId='order_type.header' />
					<div>
						<RadioGroup
							field='order_type[brands][value]'
							initialValue={order_type.brands.value}
							onValueChange={(ev) => setOrderType(ev)}
						>
							{order_type &&
								order_type.brands.dyn_data.map((brand) => {
									if (brand.sys_name != 'andre' && brand.sys_name != '__empty__') {
										return (
											<ProjectRadioFreeContainer
												label={brand.name}
												value={brand.sys_name}
												key={brand.sys_name}
											/>
										);
									}
									if (brand.sys_name == 'andre') {
										return (
											<fieldset className='free-grid-item' key={brand.sys_name}>
												<label>
													<Radio
														className='regular'
														field={brand.sys_name}
														value={brand.sys_name}
													/>
													<span>{brand.name}</span>
												</label>
												<label>
													<Text
														type='text'
														field='order_type[branding_text][value]'
														initialValue={order_type.branding_text.value}
														allowEmptyString={true}
														disabled={
															!(formState.values.order_type?.brands?.value === 'andre')
														}
													/>
												</label>
											</fieldset>
										);
									}
								})}
						</RadioGroup>
					</div>
				</div>
				<div
					className={`dropdown-content-options ${
						(order_type_val !== 'knapphus' && order_type_val !== 'tigne') || hide_order_type
							? 'dropdown-content-options--hidden'
							: ''
					}`}
				>
					<div className='local-grid local-grid--col-2'>
						<ProjectFormTextInput
							name='order_type[knapphus][order_number][value]'
							type='text'
							label={order_type.knapphus.order_number.label}
							activeFormData={order_type.knapphus.order_number.value}
							allowEmptyString={true}
						/>
						<fieldset className='grid-item button-and-input-container'>
							<ProjectAddCommentButton
								handleShowComments={handleShowComments}
								extraClass={true}
								targetId='order_type.knapphus.order_number'
								group='order_type'
								comments={comments}
								label={order_type.knapphus.order_number.label}
							/>
							<label className='button-and-input-wrapper'>
								<span className='input-description'>
									{order_type.knapphus.delivery_date.label} {GeneralConstants['can_change_in_page_1']}
								</span>
								<div className='look-like-input'>
									{activeFormData.start_transport_datetime && activeFormData.end_transport_datetime
										? `${formatDate(activeFormData.start_transport_datetime, { outputFormat: GeneralConstants.date_format })} - ${formatDate(activeFormData.end_transport_datetime, { outputFormat: GeneralConstants.date_format })}`
										: null}
								</div>
							</label>
						</fieldset>

						<CommentFormDisplay targetId='order_type.knapphus.order_number' />

						<ButtonAndInputContainer
							inputName='order_type[knapphus][bathroom_model][value]'
							inputNameInitialValue={order_type.knapphus.bathroom_model.value}
							handleShowComments={handleShowComments}
							extraClass={false}
							targetId='order_type.knapphus.bathroom_model'
							group='order_type'
							comments={comments}
							label={order_type.knapphus.bathroom_model.label}
						/>
						<ButtonAndInputContainer
							inputName='order_type[knapphus][mirror_type][value]'
							inputNameInitialValue={order_type.knapphus.mirror_type.value}
							handleShowComments={handleShowComments}
							extraClass={false}
							targetId='order_type.knapphus.mirror_type'
							group='order_type'
							comments={comments}
							label={order_type.knapphus.mirror_type.label}
						/>
						<ButtonAndInputContainer
							inputName='order_type[knapphus][handle_type][value]'
							inputNameInitialValue={order_type.knapphus.handle_type.value}
							handleShowComments={handleShowComments}
							extraClass={false}
							targetId='order_type.knapphus.handle_type'
							group='order_type'
							comments={comments}
							label={order_type.knapphus.handle_type.label}
						/>
						<ButtonAndInputContainer
							inputName='order_type[knapphus][wall_type][value]'
							inputNameInitialValue={order_type.knapphus.wall_type.value}
							handleShowComments={handleShowComments}
							extraClass={false}
							targetId='order_type.knapphus.wall_type'
							group='order_type'
							comments={comments}
							label={order_type.knapphus.wall_type.label}
						/>
					</div>
					<div className='local-grid local-grid--col-1'>
						<ButtonAndOptionsContainer
							handleShowComments={handleShowComments}
							extraClass={true}
							targetId='order_type.knapphus.nailing'
							group='order_type'
							comments={comments}
							label={order_type.knapphus.nailing.label}
							inputName='order_type[knapphus][nailing][value]'
							inputNameInitialValue={order_type.knapphus.nailing.value}
							options={order_type.knapphus.nailing.options}
						/>
					</div>
					<div className='local-grid local-grid--col-1'>
						<fieldset className='grid-item button-and-options-container'>
							<ProjectAddCommentButton
								handleShowComments={handleShowComments}
								extraClass={true}
								targetId='order_type.knapphus.lacquer'
								group='order_type'
								comments={comments}
								label={order_type.knapphus.lacquer.label}
							/>
							<fieldset className='options-container'>
								<span className='field-description'>{order_type.knapphus.lacquer.label}</span>
								<fieldset className='local-grid local-grid--col-2 option-list'>
									<ProjectFormTextInput
										name='order_type[knapphus][lacquer][front][value]'
										type='text'
										label={`${order_type.knapphus.lacquer.front.label} (m²)`}
										activeFormData={order_type.knapphus.lacquer.front.value}
									/>
									<ProjectFormTextInput
										name='order_type[knapphus][lacquer][dekks][value]'
										type='text'
										label={`${order_type.knapphus.lacquer.dekks.label} (m²)`}
										activeFormData={order_type.knapphus.lacquer.dekks.value}
									/>
									<ProjectFormTextInput
										name='order_type[knapphus][color_code][value]'
										type='text'
										label={order_type?.knapphus?.color_code?.label}
										activeFormData={order_type?.knapphus?.color_code?.value}
									/>
									<ProjectFormTextInput
										name='order_type[knapphus][lacquer][moldings_lists][value]'
										type='text'
										label={order_type.knapphus?.lacquer?.moldings_lists?.label}
										activeFormData={order_type.knapphus?.lacquer?.moldings_lists?.value}
									/>
									<ProjectFormTextInput
										name='order_type[knapphus][lacquer][planned_week][value]'
										type='date'
										label={order_type?.knapphus?.lacquer?.planned_week?.label}
										activeFormData={order_type?.knapphus?.lacquer?.planned_week?.value}
									/>
								</fieldset>
							</fieldset>
						</fieldset>
						<CommentFormDisplay targetId='order_type.knapphus.lacquer' />
					</div>
					<div className='local-grid local-grid--col-1'>
						<label className='grid-item'>
							<span className='input-description'>{order_type.knapphus.comment.label}</span>
							<TextArea
								field='order_type[knapphus][comment][value]'
								initialValue={order_type.knapphus.comment.value}
								allowEmptyString={true}
							/>
						</label>
					</div>
				</div>
				<div
					className={`dropdown-content-options ${
						(order_type_val != 'sigdal' &&
							order_type_val != 'strai' &&
							order_type_val != 'andre' &&
							order_type_val != 'ka-garderobe') ||
						hide_order_type
							? 'dropdown-content-options--hidden'
							: ''
					}`}
				>
					<div className='local-grid local-grid--col-2'>
						<ProjectFormTextInput
							name='order_type[other][order_number][value]'
							type='text'
							label={order_type.other.order_number.label}
							activeFormData={order_type.other.order_number.value}
						/>
						<fieldset className='grid-item button-and-input-container'>
							<ProjectAddCommentButton
								handleShowComments={handleShowComments}
								extraClass={true}
								targetId='order_type.other.order_number'
								group='order_type'
								comments={comments}
								label={order_type.other.order_number.label}
							/>
							<label className='button-and-input-wrapper'>
								<span className='input-description'>
									{order_type.other.delivery_date.label} {GeneralConstants['can_change_in_page_1']}
								</span>
								<div className='look-like-input'>
									{activeFormData.start_transport_datetime && activeFormData.end_transport_datetime
										? `${formatDate(activeFormData.start_transport_datetime, { outputFormat: GeneralConstants.date_format })} - ${formatDate(activeFormData.end_transport_datetime, { outputFormat: GeneralConstants.date_format })}`
										: null}
								</div>
							</label>
						</fieldset>

						<CommentFormDisplay targetId='order_type.other.order_number' />

						<ButtonAndInputContainer
							inputName='order_type[other][bathroom_model][value]'
							inputNameInitialValue={order_type.other.bathroom_model.value}
							handleShowComments={handleShowComments}
							extraClass={false}
							targetId='order_type.other.bathroom_model'
							group='order_type'
							comments={comments}
							label={order_type.other.bathroom_model.label}
						/>
						<ButtonAndInputContainer
							inputName='order_type[other][color_code][value]'
							inputNameInitialValue={order_type.other.color_code.value}
							handleShowComments={handleShowComments}
							extraClass={false}
							targetId='order_type.other.color_code'
							group='order_type'
							comments={comments}
							label={order_type.other.color_code.label}
						/>
						<ButtonAndInputContainer
							inputName='order_type[other][mirror_type][value]'
							inputNameInitialValue={order_type.other.mirror_type.value}
							handleShowComments={handleShowComments}
							extraClass={false}
							targetId='order_type.other.mirror_type'
							group='order_type'
							comments={comments}
							label={order_type.other.mirror_type.label}
						/>
						<ButtonAndInputContainer
							inputName='order_type[other][handle_type][value]'
							inputNameInitialValue={order_type.other.handle_type.value}
							handleShowComments={handleShowComments}
							extraClass={false}
							targetId='order_type.other.handle_type'
							group='order_type'
							comments={comments}
							label={order_type.other.handle_type.label}
						/>
						<ButtonAndInputContainer
							inputName='order_type[other][wall_type][value]'
							inputNameInitialValue={order_type.other.wall_type.value}
							handleShowComments={handleShowComments}
							extraClass={false}
							targetId='order_type.other.wall_type'
							group='order_type'
							comments={comments}
							label={order_type.other.wall_type.label}
						/>
					</div>
					<div className='local-grid local-grid--col-1'>
						<ButtonAndOptionsContainer
							handleShowComments={handleShowComments}
							extraClass={true}
							targetId='order_type.other.nailing'
							group='order_type'
							comments={comments}
							label={order_type.other.nailing.label}
							inputName='order_type[other][nailing][value]'
							inputNameInitialValue={order_type.other.nailing.value}
							options={order_type.other.nailing.options}
						/>
					</div>
					<div className='local-grid local-grid--col-1'>
						<fieldset className='grid-item button-and-options-container'>
							<ProjectAddCommentButton
								handleShowComments={handleShowComments}
								extraClass={true}
								targetId='order_type.other.lacquer'
								group='order_type'
								comments={comments}
								label={order_type.other.lacquer.label}
							/>
							<fieldset className='options-container'>
								<span className='field-description'>{order_type.other.lacquer.label}</span>
								<fieldset className='local-grid local-grid--col-2 option-list'>
									<ProjectFormTextInput
										name='order_type[other][lacquer][front][value]'
										type='text'
										label={`${order_type.other.lacquer.front.label} (m²)`}
										activeFormData={order_type.other.lacquer.front.value}
									/>
									<ProjectFormTextInput
										name='order_type[other][lacquer][dekks][value]'
										type='text'
										label={`${order_type.other.lacquer.dekks.label} (m²)`}
										activeFormData={order_type.other.lacquer.dekks.value}
									/>
									<ProjectFormTextInput
										name='order_type[other][lacquer][moldings_lists][value]'
										type='text'
										label={order_type.other.lacquer.moldings_lists.label}
										activeFormData={order_type.other.lacquer.moldings_lists.value}
									/>
								</fieldset>
							</fieldset>
						</fieldset>
						<CommentFormDisplay targetId='order_type.other.lacquer' />
					</div>
					<div className='local-grid local-grid--col-1'>
						<label className='grid-item'>
							<span className='input-description'>{order_type.other.comment.label}</span>
							<TextArea
								field='order_type[other][comment][value]'
								initialValue={order_type.other.comment.value}
								allowEmptyString={true}
							/>
						</label>
					</div>
				</div>
			</div>
			<div className='dropdown-container'>
				<div
					className={`dropdown-header-container dropdown-container__header ${
						hide_sink ? 'dropdown-container__header--closed' : null
					}`}
				>
					<a href='' className='dropdown-container-trigger' onClick={(ev) => toggle(ev, 'sink')}>
						{sink.label}
					</a>
					<div className='dropdown-status-container'>
						<DropTownHeaderCheckBox
							name='sink[dates][ordered][value]'
							label={sink.dates.ordered.label}
							activeFormData={sink.dates.ordered.value === true}
						/>
						<DropTownHeaderCheckBox
							name='sink[dates][approved][value]'
							label={sink.dates.approved.label}
							activeFormData={sink.dates.approved.value === true}
						/>
						<DropTownHeaderCheckBox
							name='sink[dates][delivered][value]'
							label={sink.dates.delivered.label}
							dateName='sink[dates][delivered_date][value]'
							activeFormData={sink.dates.delivered.value === true}
							activeFormDateData={
								sink.dates.delivered_date.value ? sink.dates.delivered_date.value : todayDate
							}
							todayDate={todayDate}
						/>
						<ProjectAddCommentButton
							handleShowComments={handleShowComments}
							extraClass={false}
							targetId='sink.header'
							group='sink'
							comments={comments}
							label={sink.label}
						/>
					</div>
				</div>
				<div
					className={`local-grid local-grid--col-1 dropdown-content-initial-options ${
						hide_sink ? 'local-grid--hidden' : null
					}`}
				>
					<CommentFormDisplay targetId='sink.header' />

					<div className='local-grid local-grid--col-1'>
						<label className='grid-item'>
							<span className='input-description'>{sink.sink_description.label}</span>
							<TextArea
								field='sink[sink_description][value]'
								initialValue={sink.sink_description.value}
								allowEmptyString={true}
							/>
						</label>
					</div>
				</div>
			</div>
			<div className='dropdown-container'>
				<div
					className={`dropdown-header-container dropdown-container__header ${
						hide_doorhandle ? 'dropdown-container__header--closed' : null
					}`}
				>
					<a href='' className='dropdown-container-trigger' onClick={(ev) => toggle(ev, 'doorhandle')}>
						{doorhandle.label}
					</a>
					<div className='dropdown-status-container'>
						<DropTownHeaderCheckBox
							name='doorhandle[dates][ordered][value]'
							label={doorhandle.dates.ordered.label}
							activeFormData={doorhandle.dates.ordered.value === true}
						/>
						<DropTownHeaderCheckBox
							name='doorhandle[dates][approved][value]'
							label={doorhandle.dates.approved.label}
							activeFormData={doorhandle.dates.approved.value === true}
						/>
						<DropTownHeaderCheckBox
							name='doorhandle[dates][delivered][value]'
							label={doorhandle.dates.delivered.label}
							dateName='doorhandle[dates][delivered_date][value]'
							activeFormData={doorhandle.dates.delivered.value === true}
							activeFormDateData={
								doorhandle.dates.delivered_date.value
									? doorhandle.dates.delivered_date.value
									: todayDate
							}
							todayDate={todayDate}
						/>
						<ProjectAddCommentButton
							handleShowComments={handleShowComments}
							extraClass={false}
							targetId='doorhandle.header'
							group='doorhandle'
							comments={comments}
							label={doorhandle.label}
						/>
					</div>
				</div>
				<div
					className={`local-grid local-grid--col-2 dropdown-content-initial-options ${
						hide_doorhandle ? 'local-grid--hidden' : null
					}`}
				>
					<CommentFormDisplay targetId='doorhandle.header' />
					<label className='grid-item'>
						<span className='input-description'>{doorhandle.doorhandle_options.label}</span>
						<Select
							field='doorhandle[doorhandle_options][value]'
							className='regular'
							initialValue={doorhandle.doorhandle_options.value}
						>
							{doorhandle.doorhandle_options.options.map((option) => (
								<Option value={option.sys_name} key={option.sys_name}>
									{option.label}
								</Option>
							))}
						</Select>
					</label>
					<label className='grid-item'>
						<span className='input-description'>{doorhandle.doorhandle_text.label}</span>
						<Text
							type='text'
							field='doorhandle[doorhandle_text][value]'
							initialValue={doorhandle.doorhandle_text.value}
							allowEmptyString={true}
						/>
					</label>
				</div>
			</div>
			<div className='dropdown-container'>
				<div
					className={`dropdown-header-container dropdown-container__header ${
						hide_is_workdrawing_sent ? 'dropdown-container__header--closed' : null
					}`}
				>
					<a
						href=''
						className='dropdown-container-trigger'
						onClick={(ev) => toggle(ev, 'is_workdrawing_sent')}
					>
						{is_workdrawing_sent.label}
					</a>
					<div className='dropdown-status-container'>
						<ProjectAddCommentButton
							handleShowComments={handleShowComments}
							extraClass={false}
							targetId='is_workdrawing_sent.header'
							group='is_workdrawing_sent'
							comments={comments}
							label={is_workdrawing_sent.label}
						/>
					</div>
				</div>
				<div
					className={`local-grid local-grid--col-1 dropdown-content-initial-options ${
						hide_is_workdrawing_sent ? 'local-grid--hidden' : null
					}`}
				>
					<CommentFormDisplay targetId='is_workdrawing_sent.header' />
					<div>
						<label className='free-grid-item'>
							<Checkbox
								field='is_workdrawing_sent[value]'
								initialValue={is_workdrawing_sent.value === true}
							/>
							<span>{GeneralConstants['yes']}</span>
						</label>
					</div>
				</div>
			</div>
		</>
	);
};

export default ProjectFormBathroom;
